import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import Select2 from 'react-select2-wrapper';

import PageHeader from '../elements/PageHeader';
import NameHelper from '../../helpers/nameHelper';

class QueueListScreen extends Component {
    constructor(props) {
        super(props);

        this.searchStringChange = this.searchStringChange.bind(this);
        this.currentPeriodFilterChange = this.currentPeriodFilterChange.bind(this);
        this.handleToggleQueueCollapse = this.handleToggleQueueCollapse.bind(this);
        this.removeSupporterFromQueue = this.removeSupporterFromQueue.bind(this);
        this.setSupporterToPeriodAndRemoveFromQueue = this.setSupporterToPeriodAndRemoveFromQueue.bind(this);
    }

    componentDidMount() {
        this.props.getQueueList();
    }

    searchStringChange(e) {
        this.props.filterQueueList(e.target.value);
    }

    currentPeriodFilterChange(e) {
        this.props.currentPeriodFilterChange([...e.target.options].filter(({selected}) => selected).map(({value}) => value));
    }

    removeSupporterFromQueue(supporterId, e) {
        e.target.disabled = true;
        if(e.target.children[0]) e.target.children[0].className = 'fa fa-spinner fa-rotate';
        this.props.removeSupporterFromQueue(supporterId);
    }

    setSupporterToPeriodAndRemoveFromQueue(supporterId, e) {
        e.target.disabled = true;
        if(e.target.children[0]) e.target.children[0].className = 'fa fa-spinner fa-rotate';
        this.props.setSupporterToPeriodAndRemoveFromQueue(supporterId);
    }

    handleToggleQueueCollapse(e) {
        let queueId;
        if (e.target.tagName.toLowerCase() === 'i') {
            queueId = e.target.parentNode.getAttribute('data-queue-id');
        } else {
            queueId = e.target.getAttribute('data-queue-id');
        }
        this.props.toggleQueueCollapse(queueId);
    }

    render() {
        const {t, queues} = this.props;

        return (
            <div className="QueueListScreen">
                <PageHeader title={t('queueList.title')}/>
                <div className="row m-t-lg">
                    <div className="col-xs-12 col-md-8">
                        <input className="form-control" type="text" placeholder={t('queueList.search.placeholder')}
                               onChange={this.searchStringChange} value={this.props.searchString}/>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <Select2 multiple data={this.props.availableCurrentPeriods.map(period => period.name ? {text: t('default.period.' + period.name, {
                            startAt: moment(period.startAt).format('DD.MM.'),
                            endAt: moment(period.endAt).format('DD.MM.')
                        }), id: period.id} : null)} ref={(e) => { this.tags = e; }} value={this.props.currentPeriodsFilter} onSelect={this.currentPeriodFilterChange} onUnselect={this.currentPeriodFilterChange} options={{placeholder: t('queueList.currentPeriodsFilter.placeholder')}} className="width-100p block"/>
                    </div>
                </div>
                <div className="m-t-lg"/>
                {queues && queues.length > 0 ? (
                    queues.map((queue, i) => (
                        <div className="ibox" key={i}>
                            <div className="ibox-title">
                                <h5>
                                    {queue.periodName ? t('default.period.' + queue.periodName, {
                                        startAt: moment(queue.periodStartAt).format('DD.MM.'),
                                        endAt: moment(queue.periodEndAt).format('DD.MM.')
                                    }) : null}
                                    &nbsp;({queue.slots}/{queue.slotsTotal})
                                </h5>
                                <div className="ibox-tools">
                                    <a onClick={this.handleToggleQueueCollapse} className="collapse-link"
                                       data-queue-id={queue.id}>
                                        <i className={"fa fa-" + (queue.collapsed ? 'chevron-down' : 'chevron-up')}/>
                                    </a>
                                </div>
                            </div>
                            <div className={"ibox-content" + (queue.collapsed ? " hidden" : "")}>
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>
                                            {t('queueList.table.position')}
                                        </th>
                                        <th>
                                            {t('queueList.table.supporterName')}
                                        </th>
                                        <th>
                                            {t('queueList.table.currentPeriod')}
                                        </th>
                                        <th>
                                            {t('queueList.table.addedAt')}
                                        </th>
                                        <th/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {queue.supporters && queue.supporters.length > 0 ? (
                                        queue.supporters.map((supporter, j) => (
                                            !supporter.hidden ? (
                                                <tr key={j}>
                                                    <td>
                                                        {supporter.position}
                                                    </td>
                                                    <td>
                                                        {NameHelper.displayName(supporter.supporter)}<br/>
                                                        <span className="text-muted">
                                                            {supporter.supporter.email}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {supporter.currentPeriodName ? t('default.period.' + supporter.currentPeriodName, {
                                                            startAt: moment(supporter.currentPeriodStartAt).format('DD.MM.'),
                                                            endAt: moment(supporter.currentPeriodEndAt).format('DD.MM.')
                                                        }) : null}
                                                    </td>
                                                    <td>
                                                        {moment(supporter.addedAt).format('DD.MM.YYYY')}
                                                    </td>
                                                    <td className="text-right">
                                                        <div className="btn-group">
                                                            <button className="btn btn-warning" key={"sstparfq" + supporter.supporter.id}
                                                                    onClick={(e) => this.setSupporterToPeriodAndRemoveFromQueue(supporter.supporter.id, e)}>
                                                                <i className="fa fa-check"/>
                                                            </button>
                                                            <button className="btn btn-danger" key={"rsfq" + supporter.supporter.id}
                                                                    onClick={(e) => this.removeSupporterFromQueue(supporter.supporter.id, e)}>
                                                                <i className="fa fa-trash"/>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : null
                                        ))
                                    ) : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))
                ) : null}
            </div>
        )
    }
}

export default translate()(QueueListScreen);